<template>
    <div class="Account">
        <div class="container">
            <div class="row">
                <div class="col-12 " v-if="user.type == 0">

                    <!-- Card -->
                    <div class="card card-cascade cascading-admin-card user-card my-5">

                        <!-- Card Data -->
                        <div class="admin-up d-flex justify-content-start p-3">
                            <h1 class="font-weight-bold mb-0">Profil</h1>

                        </div>
                        <!-- Card Data -->

                        <!-- Card content -->
                        <div class="card-body card-body-cascade">

                            <div class="row">
                                <div class="col-6 text-left">
                                    <mdb-input label="Email" v-model="user.accountidentifier" />
                                </div>
                                <div class="col-6 text-left">
                                    <mdb-input label="Neues Passwort" ype="password" v-model="newPassword" />
                                    <mdb-input label="Neues Passwort bestätigen" ype="password" v-model="newPasswordvalid" />
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="d-flex ">
                                        <mdb-btn color="danger" v-on:click="deleteUser">Account löschen</mdb-btn>
                                        <mdb-btn color="primary"  @click.native.prevent="saveUserAdmin()">Speichern</mdb-btn>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Card content -->

                    </div>
                    <!-- Card -->

                </div>
                <div class="col-12 profile-mieter" v-else-if="user.type == 1">

                    <!-- Card -->
                    <div class="card card-cascade cascading-admin-card user-card my-5">

                        <!-- Card Data -->
                        <div class="admin-up d-flex justify-content-start p-3">
                            <h1 class="font-weight-bold mb-0">{{$t('Global.Profil')}}</h1>

                        </div>
                        <!-- Card Data -->

                        <!-- Card content -->
                        <div class="card-body card-body-cascade">

                            <div class="row">
                                <div class="col-12 col-md-4 text-left">
                                    <mdb-select v-model="status" @change="changeStatus($event)" :label="$t('Mieter.Status')" :placholder="$t('Global.Auswahlen')"></mdb-select>
                                </div>
                                <div class="col-12 col-md-4 text-left">
                                    <mdb-select v-model="institution" @change="changeInstitut($event)" :label="$t('Mieter.Institution')" :placholder="$t('Global.Auswahlen')"></mdb-select>
                                </div>
                                <div class="col-12 col-md-4">
                                    <mdb-input :label="$t('Mieter.Institutiongruppe')" v-model="user.institutionuntergruppe" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-4">
                                    <mdb-input :label="$t('Mieter.Vorname')" v-model="user.vorname" />

                                </div>
                                <div class="col-12 col-md-4">
                                    <mdb-input :label="$t('Mieter.Nachname')" v-model="user.nachname" />
                                </div>
                                <div class="col-12 col-md-4">
                                    <mdb-select v-model="country" @change="changeCountry($event)" :label="$t('Mieter.Nationalitaet')" :placholder="$t('Global.Auswahlen')" ></mdb-select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-4">
                                    <mdb-date-picker v-model="user.aufenthaltvon" :option="option" :label="$t('Mieter.Aufenhaltvon')"/>

                                </div>
                                <div class="col-12 col-md-4">
                                    <mdb-date-picker v-model="user.aufenthaltbis" :option="option" :label="$t('Mieter.Aufenhaltbis')"/>

                                </div>
                                <div class="col-12 col-md-4">
                                    <mdb-input :label="$t('Mieter.Sonstiges')" v-model="user.sonstiges" />
                                </div>

                            </div>
                            <div class="row  my-3">

                                <div class="col-12 col-md-4">
                                    <div class="text-left">
                                        <label>{{$t('Mieter.Geschlecht')}}</label>
                                        <mdb-input type="radio" id="geschlecht-1" name="geschlecht" radioValue="w" v-model="user.geschlecht" :label="$t('Mieter.Weiblich')" />
                                        <mdb-input type="radio" id="geschlecht-2" name="geschlecht" radioValue="m" v-model="user.geschlecht" :label="$t('Mieter.Maenlich')" />

                                    </div>
                                </div>
                                <div class="col-12 col-md-4   mt-3 mt-md-0">
                                    <div class="text-left">
                                        <label> {{$t('Mieter.Familie')}}</label>
                                        <mdb-input type="radio" id="familie-1" name="familie" radioValue="1" v-model="user.mitfamilie" :label="$t('Global.Ja')" />
                                        <mdb-input type="radio" id="familie-2" name="familie" radioValue="0" v-model="user.mitfamilie" :label="$t('Global.Nein')" />

                                    </div>
                                </div>
                            </div>
                            <div class="row">

                                <div class="col-12 col-md-4 ">
                                    <mdb-input :label="$t('Mieter.Email')" v-model="user.accountidentifier" />
                                </div>
                                <div class="col-12 col-md-4 ">
                                    <mdb-input type="password" :label="$t('Mieter.Password')" v-model="newPassword" autocomplete="off" />
                                </div>
                                <div class="col-12 col-md-4 ">
                                    <mdb-input type="password" :label="$t('Mieter.Passwordconfirm')" v-model="newPasswordvalid" autocomplete="off" />
                                </div>


                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="d-flex justify-content-between">
                                        <mdb-btn color="danger" v-on:click="confirmDelete()">{{$t('Global.Deleteaccount')}}</mdb-btn>
                                        <mdb-btn color="primary"  @click.native.prevent="saveUserSuchend()">{{$t('Global.Speichern')}}</mdb-btn>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Card content -->

                    </div>
                    <!-- Card -->

                </div>
            </div>
        </div>
        <div class="confirm__remove" v-bind:class="{active: confirm == true}">
            <div class="inner d-flex justify-content-center align-items-center flex-column">
                <h2 class="text-center"> {{$t('Global.DeleteaccountHeadline')}}</h2>

                <div class="d-flex mt-5">
                    <div class="btn btn-outline-danger" v-on:click="confirmRemove(true)">{{$t('Global.Deleteaccount')}}</div>
                    <div class="btn btn-outline-danger" v-on:click="confirmRemove(false)">{{$t('Global.Abbrechen')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mdbBtn, mdbInput, mdbDatePicker, mdbSelect } from 'mdbvue';
    import settings from '@/components/Settings.json';
   import { authComputed } from '@/helpers/helper.js';
   import UserService from "../../services/UserService";
    import format from 'date-fns/format'
    export default {
        name: "Profil",
        components: {
            mdbBtn,
            mdbInput,
            mdbDatePicker,
            mdbSelect
            
        },
        props: {
        },
        data() {
            return {
                confirm: false,
                user: Object,
                newPassword: "",
                newPasswordvalid: "",
                Texte: "",
                status: [

                ],
                institution: [
                ],
                option: {
                    format: 'D.M.YYYY',
                    week: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
                    month: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'July', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                    buttons: {
                        ok: 'Ok',
                        cancel: 'Abbrechen',
                        today: 'Heute',
                        clear: 'Löschen'
                    }
                },
                country: settings.Settings[1][this.$store.getters.lang][0].country,
            };
        },
        methods: {
            confirmDelete(){
                this.confirm = true;
            },
            confirmRemove(state){
                if(state){
                    this.confirm = false;
                    this.deleteUser();
                } else {
                    this.confirm = false;
                }
            },
            deleteUser(){
                UserService.deleteUserMieter(this.user.account).then(response => {
                    this.$store.dispatch("logout")
                        .then(() => this.$router.push("/login"))
                        .catch(err => console.log(err));

                })
            },
            changeStatus(event){
                this.user.status = event;
            },
            changeInstitut(event){
                this.user.institution = event;
            },
            changeCountry(event){
                this.user.nationalitaet = event;
            },
            selectStatus(key) {
                this.status.forEach(option => {
                    if(option.value == key){
                        option.selected = true;
                    } else {
                        option.selected = false;
                    }
                });
            },
            selectInstitut(key) {
              console.log(key, this.institution)
                this.institution.forEach(option => {
                    if(option.value.toLowerCase() == key.toLowerCase()){
                        option.selected = true;
                    } else {
                        option.selected = false;
                    }
                });
            },
            selectCountry(key) {
                this.country.forEach(option => {
                    if(option.value == key){
                        option.selected = true;
                    } else {
                        option.selected = false;
                    }
                });
            },
            saveUserSuchend(){
                if(this.newPassword != ""){
                    if( this.newPassword === this.newPasswordvalid){
                        this.user.credentialssource = this.newPassword;
                        this.user.aufenthaltvon = this.$func.formateDateForDB(this.user.aufenthaltvon);
                        this.user.aufenthaltbis = this.$func.formateDateForDB(this.user.aufenthaltbis);


                        UserService.editUserSuchender(this.user).then(response => {
                            this.$store.dispatch("updateUser", this.user)
                            this.user.aufenthaltvon = this.$func.formateDateFromDB(this.user.aufenthaltvon);
                            this.user.aufenthaltbis = this.$func.formateDateFromDB(this.user.aufenthaltbis);
                            this.$notify.success({
                                message: "Ihr Account wurde aktualisiert!",
                                position: 'top right',
                                timeOut: 4000
                            });
                        })
                            .catch(e => {
                                this.$notify.warn({
                                    message: "Ihr Account konnte nicht aktualisiert werden!",
                                    position: 'top right',
                                    timeOut: 4000
                                });
                                console.log(e);

                            });
                    } else {
                        this.$notify.error({
                            message: "Passwörter stimmen nicht überein!",
                            position: 'top right',
                            timeOut: 4000
                        });
                    }
                } else {
                    this.user.aufenthaltvon = this.$func.formateDateForDB(this.user.aufenthaltvon);
                    this.user.aufenthaltbis = this.$func.formateDateForDB(this.user.aufenthaltbis);
                    UserService.editUserSuchender(this.user).then(response => {
                        this.$store.dispatch("updateUser", this.user)
                        this.$notify.success({
                            message: "Ihr Account wurde aktualisiert!",
                            position: 'top right',
                            timeOut: 4000
                        });
                        this.user.aufenthaltvon = this.$func.formateDateFromDB(this.user.aufenthaltvon);
                        this.user.aufenthaltbis = this.$func.formateDateFromDB(this.user.aufenthaltbis);
                    })
                        .catch(e => {
                            this.$notify.warn({
                                message: "Ihr Account konnte nicht aktualisiert werden!",
                                position: 'top right',
                                timeOut: 4000
                            });
                            console.log(e);

                        });
                }
                },

        },
        mounted: function() {
            let getUser = _.clone(this.$store.getters.userObject);
                if(typeof(getUser) === "string" || getUser instanceof String){
                    let user =  JSON.parse(getUser);
                     this.user = user;
                } else {
                     this.user = getUser;
                }
                this.status = settings.Settings[1][this.$store.getters.lang][0].Bevorzugte;
                this.institution = settings.Settings[1][this.$store.getters.lang][0].Institution;
                this.selectStatus(this.user.status.toLowerCase());
                this.selectInstitut(this.user.institution.toLowerCase());
                this.selectCountry(this.user.nationalitaet);
                if(!this.$func.hasFrontendFormat(this.user.aufenthaltvon)){
                    this.user.aufenthaltvon = this.$func.formateDateFromDB(this.user.aufenthaltvon);
                    this.user.aufenthaltbis = this.$func.formateDateFromDB(this.user.aufenthaltbis);
                }

                //this.user.aufenthaltvon = format(this.user.aufenthaltvon , 'D.M.YYYY');
                //this.user.aufenthaltbis = format(this.user.aufenthaltbis , 'D.M.YYYY');
                if(this.user.mitfamilie == "ja" || this.user.mitfamilie == "Ja"){
                    this.user.mitfamilie = "1";
                } else if(this.user.mitfamilie == "nein" || this.user.mitfamilie == "Nein"){
                    this.user.mitfamilie = "0";
                }

        
        },
        created() {
            this.Texte = this.$locales.Texte;
        }
    };
</script>